// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"c69f16a9","248":"afe9312f","274":"1710dbf1","320":"93f5d32c","328":"ba0f7555","331":"48da1395","418":"d24e997e","488":"b5d260cb","551":"9faf92eb","783":"7b7ed94f","794":"8079f501","831":"d269ab07","842":"ca8f9a99"}[chunkId] + ".chunk.js";
};